:host {
    display: block;
    position: relative;
}

:host([level='1']) {
    left: 24px;
}

:host(.hide) {
    display: none;
}
